import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllHikeDetails = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.HikeDetail}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getHikeDetailById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmployeeSalaryHike}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertHikeDetail = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.EmployeeSalaryHike,
    input
  );
  return data;
};

const updateHikeDetail = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.EmployeeSalaryHike,
    input
  );
  return data;
};

const deleteHikeDetail = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.EmployeeSalaryHike}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetHikeDetailsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeSalaryHike],
    queryFn: () => getAllHikeDetails(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetHikeDetailByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmployeeSalaryHike],
    queryFn: () => getHikeDetailById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertHikeDetailMutation = () => {
  return useMutation({
    mutationFn: insertHikeDetail,
  });
};

export const useUpdateHikeDetailMutation = () => {
  return useMutation({
    mutationFn: updateHikeDetail,
  });
};

export const useDeleteHikeDetailMutation = () => {
  return useMutation({
    mutationFn: deleteHikeDetail,
  });
};
